import React, { useContext } from 'react';

import { EmailContext } from 'containers/pages/Email/emailContext';
import { ShadowDomainsTable } from 'containers/pages/Email/ShadowDom';

import DomainRow from './components/DomainRow';

const DomainList = ({ toggleModal, toggleDrawer }) => {
  const {
    emailState: { domainsList, domainsListIsLoading },
  } = useContext(EmailContext);

  return (
    <>
      {domainsListIsLoading && <ShadowDomainsTable />}
      {!domainsListIsLoading &&
        Object.values(domainsList).map((step, index) => {
          const domain = {
            name: step.name,
            status: step.status,
          };

          return (
            <DomainRow
              key={index}
              domain={domain}
              toggleModal={toggleModal}
              toggleDrawer={toggleDrawer}
            />
          );
        })}
    </>
  );
};

export default DomainList;
